<template>
  <div>

  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {}
  },
  created() {
    this.dispatch()
  },
  methods: {
    ...mapActions(['login', 'logout']),
    dispatch() {
      const token = this.$route.query?.token ?? null
      if (!token || token.length === 0) {
        this.$router.replace({ path: '/user/caserror' })
        return
      }
      const loginData = { casToken: token }
      this.logout().finally(() => {
        this.login(loginData).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.$router.push({ path: '/' })
            }, 100);
          } else {
            this.$message.error(res.message || this.$t('登录失败'))
          }
        }).finally(() => {
          
        })
      })
    }
  }
}
</script>